/**
 * About 3 — Institute section: title + accent, body copy, image column, Know More CTA.
 */

/** Default rich HTML for the editor (paragraphs match front-end typography). */
const SAMPLE_DESCRIPTION_HTML = `<p>Dedicated to the Service of the Nation</p><p>The motto of IIT Kharagpur is योगः कर्मसु कौशलम्. It is commonly rendered as Excellence in action is Yoga, conveying the belief that the highest form of discipline lies in the quality of one's work.</p>`;

export const ABOUT_5_CONSTANTS = {
  ABOUT_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Title (before accent)",
      value: "About",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. About",
      required: false,
      defaultValue: "About",
    },
    {
      fieldName: "title_text_color",
      label: "Title text color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "title_1",
      label: "Title accent (institute name, primary colour)",
      value: "IIT Kharagpur",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. IIT Kharagpur",
      required: false,
      defaultValue: "IIT Kharagpur",
    },
    {
      fieldName: "title_1_color",
      label: "Accent colour (empty = theme primary)",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Leave empty for default primary",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "description",
      label: "Description",
      value: SAMPLE_DESCRIPTION_HTML,
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "Edit in the rich text editor — preview while editing",
      required: false,
      defaultValue: SAMPLE_DESCRIPTION_HTML,
    },
    {
      fieldName: "description_text_color",
      label: "Description text colour",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Empty = body-5 / gray-500 on large screens",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "desktop_image",
      label: "Desktop image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_image",
      label: "Mobile image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Falls back to desktop image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_image",
      label: "Image alt text",
      value: "About",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "About",
    },
    {
      fieldName: "read_more_text",
      label: "CTA label",
      value: "Know More",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "Know More",
    },
    {
      fieldName: "read_more_color",
      label: "CTA text colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "read_more_background_color",
      label: "CTA background (uses theme primary if empty)",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #291973 or leave empty for bg-primary",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "background_color",
      label: "Section background colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Default #FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_link",
      label: "CTA link (URL)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "/about or https://… — used when Is CTA is off",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "is_cta",
      label: "Is CTA",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder:
        "On = open lead capture popup instead of CTA link",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "image_on_right",
      label: "Image on right (default: left)",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "On = image column on the right on desktop",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
